import { render, staticRenderFns } from "./template-receipt-save.vue?vue&type=template&id=1d0e3bc2"
import script from "./template-receipt-save.vue?vue&type=script&lang=js"
export * from "./template-receipt-save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports